export default __webpack_public_path__ + "static/media/check.22add556.svg";